<template>
  <div>
    <header-navigation v-if="showArrow" not-fixed />

    <slot />
  </div>
</template>

<script>
import HeaderNavigation from 'src/components/miscellaneous/ui/common/HeaderNavigation.vue'
export default {
  name: 'SduiLogin',
  components: { HeaderNavigation },
  props: {
    showArrow: {
      default: true,
      type: Boolean,
    },
  },
}
</script>
